import { FunctionComponent, SVGProps } from 'react'

export const IconExpert: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const paint0 = `${id}-paint0`
  const paint1 = `${id}-paint1`
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.1654 24.5V22.1667C22.1654 20.929 21.6737 19.742 20.7985 18.8668C19.9234 17.9917 18.7364 17.5 17.4987 17.5H10.4987C9.26102 17.5 8.07404 17.9917 7.19887 18.8668C6.3237 19.742 5.83203 20.929 5.83203 22.1667V24.5"
        stroke={`url(#${paint0})`}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9987 12.8333C16.576 12.8333 18.6654 10.744 18.6654 8.16667C18.6654 5.58934 16.576 3.5 13.9987 3.5C11.4214 3.5 9.33203 5.58934 9.33203 8.16667C9.33203 10.744 11.4214 12.8333 13.9987 12.8333Z"
        stroke={`url(#${paint1})`}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={paint0}
          x1="13.9987"
          y1="17.5"
          x2="13.9987"
          y2="24.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.8"
          />
          <stop
            offset="1"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.6"
          />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="13.9987"
          y1="3.5"
          x2="13.9987"
          y2="12.8333"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.8"
          />
          <stop
            offset="1"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.6"
          />
        </linearGradient>
      </defs>
    </svg>
  )
}
